import { useEffect, useRef, useState } from 'react';
function NavBar({ title, onLeftButtonClick, onRightButtonClick }) {
  const navBarRef = useRef(null);
  const [navBarHeight, setNavBarHeight] = useState(0);

  useEffect(() => {
    const navBar = navBarRef.current;
    if (!navBar) return;
    const updateHeight = () => {
      setNavBarHeight(navBar.offsetHeight);
    };
    updateHeight();
    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(navBar);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  return (
    <div className="nav-bar-container">
      <div
        className="nav-bar-spacer"
        style={{ height: `${navBarHeight}px` }}></div>
      <div className="nav-bar" ref={navBarRef}>
        <div className="nav-bar__content">
          {/* <div className="nav-bar__button-container">
            <div className="nav-bar__button" onClick={onLeftButtonClick}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none">
                <path
                  d="M15 19L8 12L15 5"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div> */}
          <p className="nav-bar__title">{title}</p>
          {/* <div className="nav-bar__button-container">
            <div className="nav-bar__button" onClick={onRightButtonClick}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none">
                <path
                  d="M5 5.15381L18.1306 18.2844"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M5 18.1306L18.1306 4.999993"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          </div> */}
        </div>
        <div className="nav-bar__light-effect">
          <svg
            width="100%"
            height="1"
            viewBox="0 0 390 1"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0.5H390" stroke="url(#nav-line-gradient)" />

            <defs>
              <linearGradient
                id="nav-line-gradient"
                x1="0"
                y1="0"
                x2="390"
                y2="0"
                gradientUnits="userSpaceOnUse">
                <stop offset="0.039088" stopColor="#262424" />
                <stop offset="0.25" stopColor="#A59B80" />
                <stop offset="0.504808" stopColor="#F8E6C1" />
                <stop offset="0.745192" stopColor="#A59B80" />
                <stop offset="1" stopColor="#262424" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  );
}

export default NavBar;
